<template>
  <L1>
    <template slot="slot_title">
      <RT v-if="storeType==='restaurant'" :style="{marginLeft: 'auto', marginRight: '32px'}" :options="['佔桌概況', '時段統計']" :defaultValue="page" @input="page=$event"></RT>
      <RT v-else-if="storeType==='shop'" :style="{marginLeft: 'auto', marginRight: '32px'}" :options="[ '時段統計', '商品統計', '排單製作']" :defaultValue="page" @input="page=$event"></RT>
      <RT v-else-if="storeType==='tickets'" :style="{marginLeft: 'auto', marginRight: '32px'}" :options="[ '時段統計', '商品統計']" :defaultValue="page" @input="page=$event"></RT>
    </template>
    <L2 :ratio="'1fr 500px'" id="restCalendar">
      <Calendar slot="left" :dateSelect="date" @datechange="date=$event;category=null"
      @monthchange="start=$event" :startDate="start" :holidays="holidays"
      :dateClosed="Object.values(results).filter(e => e.reason).map(e => e.df)">
        <template slot="calendarTop">
          <Select1 :width="'-webkit-fill-available'" :height="'50px'" :defaultValue="store" @input="store=$event">
            <option v-for="(rest, r) in restaurants" :key="`restaurants-${r}`" :value="rest">{{rest}}</option>
          </Select1>
        </template>
        <div  slot-scope="{d}" :class="results&&results[d]?.reason ? results[d]?.reason==='店休' ? '關' : '滿' : ''">
        <div v-if="results&&results[d]?.reason&&!(results[d]?.group||results[d].production)" class="fulled" :title="results[d]?.reason" :class="(
            results[d]?.reason==='店休' ? '店休' :
            new RegExp('電話', 'ig').test(results[d]?.reason) ? '電洽' :
            new RegExp('包場', 'ig').test(results[d]?.reason) ? '包場' :
            new RegExp('滿', 'ig').test(results[d]?.reason) ? '額滿' : ''
          )">
          {{(
            results[d]?.reason==='店休' ? '店休' :
            new RegExp('電話', 'ig').test(results[d]?.reason) ? '電洽' :
            new RegExp('包場', 'ig').test(results[d]?.reason) ? '包場' :
            new RegExp('滿', 'ig').test(results[d]?.reason) ? '額滿' : ''
          )}}
        </div>
        <div v-else-if="results&&(results[d]?.group||results[d].production)" class="dayresult">
          <div class="fulled2" :class="(
            results[d]?.reason==='店休' ? '店休' :
            new RegExp('電話', 'ig').test(results[d]?.reason) ? '電洽' :
            new RegExp('包場', 'ig').test(results[d]?.reason) ? '包場' :
            new RegExp('滿', 'ig').test(results[d]?.reason) ? '額滿' : ''
          )" v-if="results[d]?.reason">{{results[d]?.reason}}</div>
          <div><span class="name">{{ storeType==='shop'?'預購':'預約'}}</span><span>{{results[d]?.group}}</span>{{ storeType==='shop'?'單':'組'}}</div>
          <template v-if="storeType==='shop'">
            <div><span class="name" :style="{color: 'var(--自取)'}">自取</span><span>{{results[d]?.pickup}}</span>{{ storeType==='shop'?'單':'組'}}</div>
            <div><span class="name" :style="{color: 'var(--宅配)'}">宅配</span><span>{{results[d]?.deliver}}</span>{{ storeType==='shop'?'單':'組'}}</div>
            <div><span class="name" :style="{color: 'var(--highlight)'}">製作</span><span>{{results[d]?.production}}</span>{{'組'}}</div>
          </template>
          <template  v-if="storeType!=='shop'">
          <div><span class="name">人數</span><span>{{results[d]?.num}}</span>位</div>
          <div><span class="name" :style="{color: 'var(--highlight)'}">桌菜</span><span>{{results[d]?.tabs?.toFixed(1)||0}}</span>桌</div>
          <div><span class="name" :style="{color: 'var(--color-number-2)'}">套餐</span><span>{{results[d]?.sets?.toFixed(0)||0}}</span>套</div>
          </template>
        </div>
        </div>
      </Calendar>
      <CSide :date="date" v-if="page==='佔桌概況'" :style="{margin: '34px 32px 44px 1px'}">
        <template>
          <template v-if="dataSelected">
          <Select1 :width="'-webkit-fill-available'" :defaultValue="dataSelected?.reason||null" @input="updateStatus($event)" :class="dataSelected?.reason===null?'':'highlight'">
            <option :value="null">開放預約</option>
            <option v-for="res in reasons" :key="res" :value="res" :style="{color: 'var(--highlight)'}">{{res}}</option>
          </Select1>
          <template  v-for="(sum, s) in dataSelected.statuses">
            <hoverSelectVue :page="page" :key="`sum-${s}`" :style="{marginBlock: '15px'}" v-if="sum" class="day-hour-summary" :storeType="storeType"
            :s="s" :sum="sum" :d="date" @update="updateHrStatus($event, s)" :store="store">
            </hoverSelectVue>
          </template>
          </template>
        </template>
      </CSide>
      <CSide :date="date" v-else-if="page==='時段統計'" :style="{margin: '34px 32px 44px 1px'}">
        <template>
          <template v-if="dataSelected">
          <Select1 :width="'-webkit-fill-available'" :defaultValue="dataSelected?.reason||null" @input="updateStatus($event)" :class="dataSelected?.reason===null?'':'highlight'">
            <option :value="null">開放預約</option>
            <option v-for="res in reasons" :key="res" :value="res" :style="{color: 'var(--highlight)'}">{{res}}</option>
          </Select1>
          <template  v-for="(sum, s) in dataSelected.statuses">
            <hoverSelectVue2 :page="page" :key="`sum-${s}`" :style="{marginBlock: '15px'}" v-if="sum" class="day-hour-summary" :storeType="storeType"
            :s="s" :sum="sum" :d="date" @update="()=>{}" :store="store">
            </hoverSelectVue2>
          </template>
          </template>
        </template>
      </CSide>
      <div v-else-if="page==='排單製作'" :style="{borderLeft: '1px solid var(--color-border)', maxHeight: 'calc(100vh - 90px)', overflowY: 'auto'}" id="preorderList">
        <div :style="{marginTop: '33px'}">【排單製作商品數量統計】</div>
        <div :style="{marginBlock: '18px 0'}"><RT :options="['訂單', '單品', '無']" :defaultValue="bySheet" @input="bySheet=$event"/></div>
        <div :style="{marginTop: '18px'}">
          <Select :defaultValue="categoryP" @input="categoryP=$event" :width="'350px'" :color="'var(--color-checked)'">
            <option :value="null">全部</option>
            <option v-for="(cate, c) in catesP" :key="`cate-${c}`" :value="cate._id" :style="{display: 'inline-flex'}">{{cate._id}} &nbsp;&nbsp;&nbsp; {{(cate.items || []).length}}項 &nbsp;&nbsp;&nbsp; 共計{{reduce((cate.items || []).map(e => e.count))}}組/個</option>
          </Select>
          <RoundBtn :bg="'var(--color-checked)'" :icon="'print'" :style="{paddingInline: '12px', marginLeft: 'auto'}"
           @click="print('prodsMake')"/>
        </div>
        <TableDef :rows="bySheet === '無' ? prodsA : prodsP" :style="{marginTop:'18px'}">
          <template slot="slot_head">
            <th :style="{textAlign: 'start', width: 'inherit'}">商品名稱</th>
            <th :style="{width: '90px', maxWidth: '90px'}">數量</th>
          </template>
          <template slot-scope="{item, index}">
            <tr :style="{height: '65px'}">
              <td :style="{textAlign: 'start'}">{{item.name}}</td>
              <td>{{item.count}}</td>
            </tr>
            <template v-if="bySheet === '訂單'">
              <template  v-for="(its, i) in item.items">
              <tr v-for="(it, j) in its" :key="`it-${index}-${i}-${j}`" :style="{height: '45px'}">
                <td :style="{textAlign: 'start', paddingLeft: '3em'}">
                  {{i+1}}. {{it.name}}
                  <span v-if="((it.opt&&it.opt.length>0) || (it.add&&it.add.length>0) || it.remark)" :style="{color: '#CACACA', marginLeft:'1.5em'}">
                  <br>&nbsp;&nbsp;&nbsp;&nbsp;{{[...(it.opt || []), ...(it.add || []).map(e => `${e.name || e.item.name}${e.price ? '_+' : ''}${e.price || ''}`), it.remark].filter(e => e).join(' | ')}}
                </span></td>
                <td>{{it.count}}</td>
              </tr>
              </template>
            </template>
            <template v-else-if="bySheet === '單品'">
              <template  v-for="(it, i) in item.tids_items" >
                <tr :key="`it-${index}-${i}`" :style="{height: '45px'}">
                  <td :style="{textAlign: 'start', paddingLeft: '3em'}">
                    {{String.fromCharCode(97+i)}}. {{it.name}}
                  </td>
                  <td>{{it.count}}</td>
                </tr>
                <template v-if="!(it.ops.length===1&&it.ops[0].opt==='')">
                <tr v-for="(op, o) in it.ops" :key="`op-${index}-${i}-${o}`" :style="{height: '45px'}">
                  <td :style="{textAlign: 'start', paddingLeft: '4em'}">
                    {{o+1}}. {{op.opt || '基礎'}}
                  </td>
                  <td>{{op.count}}</td>
                </tr>
                </template>
              </template>
            </template>
          </template>
        </TableDef>
      </div>
      <div v-else-if="page==='商品統計'" :style="{borderLeft: '1px solid var(--color-border)', maxHeight: 'calc(100vh - 90px)', overflowY: 'auto'}" id="preorderList">
        <div :style="{marginTop: '33px'}">【預購商品數量統計】</div>
        <div :style="{marginTop: '18px'}">
          <Select :defaultValue="category" @input="category=$event" :width="'350px'" :color="'var(--color-checked)'">
            <option :value="null">全部</option>
            <option v-for="(cate, c) in cates" :key="`cate-${c}`" :value="cate._id" :style="{display: 'inline-flex'}">{{cate._id}} &nbsp;&nbsp;&nbsp; {{(cate.items || []).length}}項 &nbsp;&nbsp;&nbsp; 共計{{reduce((cate.items || []).map(e => e.count))}}組/個</option>
          </Select>
          <RoundBtn :bg="'var(--color-checked)'" :icon="'print'" :style="{paddingInline: '12px', marginLeft: 'auto'}"
           @click="print('prodsSale')"/>
        </div>
        <TableDef :rows="prods" :style="{marginTop:'18px'}">
          <template slot="slot_head">
            <th :style="{textAlign: 'start'}">商品名稱</th>
            <th :style="{width: '90px'}">數量</th>
          </template>
          <tr slot-scope="{item}" :style="{height: '65px'}">
            <td :style="{textAlign: 'start'}">{{item.name}}</td>
            <td>{{item.count}}</td>
          </tr>
        </TableDef>
      </div>
    </L2>
    <PrintTempVue :date="date" :prods="prodsPrint || []"  :label="'商品統計'" class="prodsSale"/>
    <PrintTempProdVue :date="date" :bySheet="bySheet" :cate="bySheet==='無' ? catesP2 : catesP1" :adds="adds"
    :prods="bySheet==='無' ? prodsA : prodsP" :label="'排單製作'" class="prodsMake" />
  </L1>
</template>

<script>
import stringifyCss from './print/css.js'
import PrintTempVue from './print/printsum.vue'
import PrintTempProdVue from './print/printsumProduction.vue'
import Select from '../../components/selectcolor2.vue'
import RoundBtn from '../../components/btn/round.vue'
import TableDef from '../../components/tables/t2.vue'
import CSide from '../../components/calendarSide.vue'
import L2 from '../../components/layout/La1.vue'
import Calendar from '../../components/calendar2.vue'
import { getapi, postapi } from '../../store/fetch'
// import hourVue from './calendar/hour.vue'
import hoverSelectVue from './calendar/hourSwitch.vue'
import hoverSelectVue2 from './calendar/hourSwitch3.vue'
import L1 from '../../components/layout/L1.vue'
import { mapState } from 'vuex'
export default {
  components: {
    TableDef,
    L2,
    CSide,
    Calendar,
    RoundBtn,
    Select,
    // hourVue,
    hoverSelectVue,
    hoverSelectVue2,
    PrintTempVue,
    PrintTempProdVue,
    L1
  },
  data () {
    return {
      bySheet: '訂單',
      reasons: ['預約額滿', '店休', '特殊節日僅開放電話預約', '活動包場'],
      page: '時段統計',
      wdy: ['一', '二', '三', '四', '五', '六', '日'],
      start: this.moment().startOf('month').format('yyyy-MM-DD'),
      date: this.moment().format('yyyy-MM-DD'),
      result: null,
      results: null,
      summary: [],
      store: null,
      category: null,
      categoryP: null,
      holidays: []
    }
  },
  computed: {
    cates () {
      return (this.dataSelected?.prods || [])
    },
    catesP () {
      const p = (this.dataSelected?.prodsP || [])
      const c = Array.from(new Set(p.map(e => e.category)))
      const catesP = c.map(category => {
        return {
          _id: category,
          items: p.filter(e => e.category === category)
        }
      })
      if (this.categoryP) {
        return catesP.filter(e => e._id === this.categoryP)
      } else {
        return catesP
      }
    },
    catesP2 () {
      const p = (this.dataSelected?.ProsExtend || [])
      const c = Array.from(new Set(p.map(e => e.category)))
      const catesP = c.map(category => {
        return {
          _id: category,
          items: p.filter(e => e.category === category)
        }
      })
      return catesP
    },
    catesP1 () {
      const p = (this.dataSelected?.prodsP || [])
      const c = Array.from(new Set(p.map(e => e.category)))
      const catesP = c.map(category => {
        return {
          _id: category,
          items: p.filter(e => e.category === category)
        }
      })
      return catesP
    },
    prodsA () {
      if (this.categoryP) {
        const find = (this.dataSelected.ProsExtend || []).filter(e => e.category === this.categoryP)
        return find || []
      } else {
        return (this.dataSelected.ProsExtend || [])
      }
    },
    prodsP () {
      if (this.categoryP) {
        const find = (this.dataSelected.prodsP || []).filter(e => e.category === this.categoryP)
        return find || []
      } else {
        return (this.dataSelected.prodsP || [])
      }
    },
    prodsPrint () {
      if (this.category) {
        const find = (this.dataSelected.prods || []).filter(e => e._id === this.category)
        return find || []
      } else {
        return (this.dataSelected.prods || [])
      }
    },
    adds () {
      if (this.dataSelected) {
        return this.dataSelected.adds
      } else {
        return []
      }
    },
    prods () {
      if (this.category) {
        const find = (this.dataSelected.prods || []).find(e => e._id === this.category)
        return find ? find.items : []
      } else {
        return [].concat(...(this.dataSelected.prods || []).map(e => e.items))
      }
    },
    storeType () {
      if (this.store) {
        return this.$store.getters.getStoreType(this.store)
      } else {
        return null
      }
    },
    dataSelected () {
      if (this.results && this.date) {
        return this.results[this.date]
      } else {
        return null
      }
    },
    startWdy () {
      return this.moment(this.start).weekday() - 1 % 7
    },
    endWdy () {
      return 7 - ((this.moment(this.start).endOf('month').weekday() - 1) % 7 + 1)
    },
    duration () {
      return this.moment(this.start).endOf('month').diff(this.moment(this.start), 'day')
    },
    ...mapState({
      restaurants: 'restaurants',
      defaultStore: 'defaultStore'
    })
  },
  async mounted () {
    this.store = this.$route.query?.page || this.defaultStore || this.restaurants[0]
    await this.getdata()
    await this.getHolidays()
  },
  watch: {
    async start () {
      await this.getdata()
      await this.getHolidays()
    },
    async store () {
      await this.getdata()
    }
  },
  methods: {
    groupsOpt (items) {
      console.table(items)
      const opts = Array.from(new Set(items.map(e => e.opt)))
      return opts.map(opt => {
        const its = items.filter(e => e.opt === opt)
        console.table(its)
        const count = its.map(e => e.count || 1).reduce((a, b) => a + b, 0)
        return { ...items.find(e => e.opt === opt), count }
      })
    },
    print (page) {
      const css = stringifyCss[page]
      const selector = '#preview.' + page
      const content = document.querySelector(selector)
      const ht = document.createElement('html')
      const head = document.createElement('head')
      const body = document.createElement('body')
      const title = document.createElement('title')
      title.innerText = `${this.moment(this.date).format('YYYY-MM-DD')} ${page === 'prodsSale' ? '商品統計' : '排單製作'}`
      const div = document.createElement('div')
      div.style.width = '200mm'
      div.style.marginInline = 'auto'
      div.innerHTML = content.innerHTML
      body.appendChild(div)
      head.appendChild(title)
      const style = document.createElement('style')
      style.media = 'print'
      style.appendChild(document.createTextNode(css))
      const style1 = document.createElement('style')
      style1.media = 'screen'
      style1.appendChild(document.createTextNode(css))
      head.appendChild(style)
      head.appendChild(style1)
      ht.appendChild(head)
      ht.appendChild(body)
      const printWin = window.open('', '', '')
      printWin.document.write(`<html>${ht.innerHTML}</html>`)
      printWin.document.close()
      setTimeout(() => {
        printWin.print()
        this.printshow = false
      }, 500)
      return false
    },
    updateHrStatus (ev, s) {
      this.results[this.date].statuses.splice(s, 1, { ...this.dataSelected.statuses[s], reason: ev })
    },
    async updateStatus (ev) {
      if (this.dataSelected.reason === ev) {
      } else {
        console.log(ev, 'updateStatus')
        const r = await postapi('restaurantStatus/date', {
          date: this.moment(this.date).startOf('day').toISOString(), time: null, reason: ev, store: this.store
        })
        if (r) {
          await this.getdata()
        }
      }
    },
    async getHolidays () {
      const h = await getapi(`holidays/month?${new URLSearchParams({ start: this.start, end: this.moment(this.start).endOf('month').toISOString() })}`)
      this.holidays = h.map(e => this.moment(e.date).format('yyyy-MM-DD'))
    },
    async getdata () {
      const r = await getapi(`restaurant/calendar?${new URLSearchParams({
        store: this.store,
        m: this.moment(this.start).month(),
        y: this.moment(this.start).year()
      })}`)
      console.log(r)
      const results = JSON.parse(JSON.stringify(r.dates))
      this.results = results
      delete r.dates
      this.result = r
    }
  }
}
</script>
<style lang="scss">
#restCalendar {
  gap: 0;
  * {
    box-sizing: border-box;
  }
  .La1_left {
    padding: 34px 45px;
    overflow-y: hidden;
  }
  .La1_right {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 1fr;
  }
  .highlight > select {
    color: var(--highlight);
  }
}
</style>
<style lang="scss" scoped>
#preorderList {
  &>div{
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding-inline: 22px 32px;
    &:nth-child(1) {
      color: var(--color-pri);
      text-align: center;
      font-feature-settings: 'clig' off, 'liga' off;
      font-family: Noto Sans TC;
      font-size: 28px;
      font-style: normal;
      font-weight: 700;
      line-height: 27px; /* 96.429% */
      letter-spacing: 2.8px;
    }
  }
}
.fulled2 {
  background-color: var(--highlight);
  color: #FFFFFF;
  font-family: 'Roboto';
  font-style: normal;
  letter-spacing: 0.1em;
  width: fit-content;
  position: absolute;
  top: 5px;
  right: 5px;
  padding: 2px 4px;
  border-radius: 2px;
  display: flex;
  text-align: center;
  &.電洽 {
    background-color: var(--color-checked);
  }
  &.店休 {
    background-color: #8C8C8C;
  }
  &.額滿 {
    background-color: #FF8B8B;
  }
  &.包場 {
    background-color: #FF8B8B;
  }
  // max-width: 3em;
}
.fulled {
  width: 74px;
  height: 74px;
  background-color: var(--highlight);
  &.電洽 {
    background-color: var(--color-checked);
  }
  &.店休 {
    background-color: #8C8C8C;
  }
  &.額滿 {
    background-color: #FF8B8B;
  }
  &.包場 {
    background-color: #FF8B8B;
  }
  border-radius: 45px;
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #FFFFFF;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  line-height: 28px;
  letter-spacing: 0.1em;
}
.dayresult {
  padding-bottom: 10px;
  &>div {
    span {
      display: inline-flex;
      font-weight: 700;
      font-size: 20px;
      line-height: 150%;
      text-align: center;
      letter-spacing: 1px;
      color: #787878;
      width: 73px;
      align-items: center;
      justify-content: center;

    }
    span.name {
      font-weight: 500;
      font-size: 16px;
      line-height: 150%;
      text-align: center;
      letter-spacing: 1px;
      padding: 0;
      margin: 0;
      color: #787878;
      width: 41px;
      align-items: center;
      justify-content: center;

    }
  }
}
.side-content {
  display: flex;
  flex-direction: column;
  background-color: #FFFFFF;
  text-align: start;
  font-weight: 400;
  font-size: 18px;
  line-height: 21px;
  letter-spacing: 0.1em;
  color: #787878;
  gap: 15px;

}
.staff {
  margin-inline: auto;
  margin-bottom: 10px;
  height: 35px;
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 20px;
  width: 130px;
  background-color: var(--color-bar);
  letter-spacing: .1em;
  &.pt {
    background-color: rgba(255, 228, 228, 0.9);
  }

}
.celendar {
  max-height: calc(100vh - 195px);
  padding-inline: 5px;
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  border-radius: 5px;
  overflow: auto;
  padding-bottom: 20px;
  box-sizing: border-box;
  &>div{
    flex:1;
  }
  .wdy {
    background-color: var(--color-pri);
    color: #FFFFFF;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 500;
    font-size: 24px;
    line-height: 27px;
    text-align: center;
    letter-spacing: 0.1em;
    &:nth-child(1) {
      border-radius: 5px 0 0 0;
    }
    &:nth-child(7) {
      border-radius:  0 5px 0 0;
    }
  }
  .day {
    min-height: 100px;
    min-height: 147px;
    border-right: 1px solid #DADADA;
    border-bottom: 1px solid #DADADA;
    &:nth-of-type(7n-6) {
      border-left: 1px solid #DADADA;
    }
    &>div:nth-child(1) {
      font-weight: 500;
      font-size: 18px;
      line-height: 27px;
      text-align: center;
      letter-spacing: 0.1em;
      color: var(--color-pri);
      padding-block: 10px;
    }
    &.selected {
      background-color: var(--color-bar);
    }
  }
}
#div1{
  position: relative;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 40px;
  padding-inline: 5px;
  &>div{
    min-width: 290px;
    font-weight: 500;
    font-size: 24px;
    line-height: 24px;
    text-align: center;
    letter-spacing: 0.1em;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--color-pri);
  }
  button {
    background-color: transparent;
  }
}
#attendance-page3 {
  display: grid;
  flex: 1;
  max-height: calc(100vh - 90px);
  grid-template-rows: 100%;
  grid-template-columns: 310px 1fr;
  &>div{
    flex: 1;
    padding-block: 20px;
    padding-inline: 20px;
    overflow-y: auto;
    height: -webkit-fill-available;
  }
  padding-inline: 47px 22px;
}
</style>
